var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMenuPayouts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6 17.45H19V19.45H13V13.45H15V16.18C16.83 14.71 18 12.47 18 9.95C18 5.88 14.94 2.51 11 2.02V0C16.05 0.5 20 4.76 20 9.95C20 12.94 18.68 15.62 16.6 17.45ZM2 9.95C2 7.43 3.17 5.18 5 3.72V6.45H7V0.45H1V2.45H3.4C1.32 4.28 0 6.96 0 9.95C0 15.14 3.95 19.4 9 19.9V17.88C5.06 17.39 2 14.02 2 9.95Z",
    fill: "black",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9352 8.96069C9.47288 8.47598 8.76634 8.172 8.76634 7.39974C8.76634 6.56176 9.67826 6.25778 10.2534 6.25778C11.3296 6.25778 11.7239 7.07112 11.8143 7.35866L13.1124 6.80822C12.9891 6.44674 12.4387 5.23906 10.927 4.97616V3.94922H9.48931V4.98438C7.35327 5.44445 7.33684 7.3258 7.33684 7.41617C7.33684 9.2811 9.18533 9.80689 10.089 10.1355C11.3871 10.5956 11.9622 11.0146 11.9622 11.8033C11.9622 12.7316 11.0996 13.126 10.3355 13.126C8.84028 13.126 8.41307 11.5897 8.36378 11.4089L7 11.9594C7.51758 13.7586 8.87314 14.2433 9.48109 14.3912V15.451H10.9188V14.4322C11.346 14.3583 13.3999 13.9475 13.3999 11.7868C13.4081 10.6449 12.907 9.64258 10.9352 8.96069Z",
    fill: "black",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuPayouts);
export default __webpack_public_path__ + "static/media/icon_menu_payouts.48c3a00a4eda3e977806d642bf643b16.svg";
export { ForwardRef as ReactComponent };